<div
    class="driver-detail-container flex flex-column gap-4 justify-content-center align-items-center"
>
    <p-card
        class="w-full"
        [header]="'DRIVER_DETAILS' | translate"
        *ngIf="driver"
    >
        <div class="border-300 border-top-1 pt-4 flex flex-column">
            <div class="flex w-full flex-wrap">
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{ driver.driver.firstname }}</span>
                    <span class="text-500 text-sm">{{
                        "FIRST_NAME" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{ driver.driver.surname }} </span>
                    <span class="text-500 text-sm">{{
                        "LAST_NAME" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        driver.driver.dateOfBirth | date
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "DATE_OF_BIRTH" | translate
                    }}</span>
                </div>
            </div>
            <div class="flex w-full flex-wrap">
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        driver.driver.identificationNumber
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "NATIONAL_IDENTIFICATION_NUMBER" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        driver.driver.gender | translate
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "GENDER" | translate
                    }}</span>
                </div>
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        driver.driver.status | translate
                    }}</span>
                    <span class="text-500 text-sm">{{
                        "STATUS" | translate
                    }}</span>
                </div>
            </div>
            <div class="flex w-full flex-wrap">
                <div class="flex flex-column pb-4 w-30rem">
                    <span class="text-900">{{
                        driver.driver.kycStatus
                            ? driver.driver.kycStatus
                            : "N/A"
                    }}</span>
                    <span class="text-500 text-sm"
                        >KYC {{ "STATUS" | translate }}</span
                    >
                </div>
            </div>
        </div>
    </p-card>
    <p-card [header]="'Driver Documents' | translate" class="w-full" *ngIf="driver">
        <p-progressBar
            *ngIf="loadingDocumentView"
            mode="indeterminate"
            [style]="{ height: '6px' }"
        />
        <p-table
            *ngIf="driver.documents.length > 0; else noDriver"
            [value]="driver.documents"
            [rowsPerPageOptions]="[10, 15, 20]"
            responsiveLayout="scroll"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>{{ "DOCUMENT_NAME" | translate }}</th>
                    <th>{{ "DOCUMENT_NAME" | translate }}</th>
                    <th>{{ "DATE_UPLOADED" | translate }}</th>
                    <th>{{ "EXPIRY_DATE" | translate }}</th>
                    <th>{{ "MIME_TYPE" | translate }}</th>
                    <th>{{ "STATUS" | translate }}</th>
                    <th>{{ "ACTIONS" | translate }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-document>
                <tr
                    [ngClass]="
                        document.status !== 'VERIFIED' ? 'orangeBg' : 'whiteBg'
                    "
                >
                    <td>
                        <span class="p-column-title">Document Name</span>
                        {{ document.documentName | translate }}
                    </td>
                    <td>
                        <span class="p-column-title">Document Number</span>
                        {{
                            document.documentNumber
                                ? document.documentNumber
                                : "---"
                        }}
                    </td>
                    <td>
                        <span class="p-column-title">Date Uploaded</span>
                        {{
                            document.uploadedDate
                                ? (document.uploadedDate | date : "short")
                                : "---"
                        }}
                    </td>
                    <td>
                        <span class="p-column-title">Expiry Date</span>
                        {{ document.expiryDate ? document.expiryDate : "---" }}
                    </td>
                    <td>
                        <span class="p-column-title">Mime Type</span>
                        {{ document.mimeType ? document.mimeType : "---" }}
                    </td>
                    <td>
                        <span class="p-column-title">Status</span>
                        {{
                            document.status
                                ? (document.status | translate)
                                : "---"
                        }}
                    </td>
                    <td>
                        <span class="p-column-title">Actions</span>
                        <p-button
                            icon="pi pi-info-circle"
                            *ngIf="document.status !== 'VERIFIED'"
                            (onClick)="getKycDocument(document.id)"
                            [pTooltip]="'VIEW_DOCUMENT' | translate"
                            [rounded]="true"
                            severity="success"
                        />
                        <div
                            class="w-3rem"
                            [pTooltip]="'DOCUMENT_VERIFIED_TOOLTIP' | translate"
                            *ngIf="document.status === 'VERIFIED'"
                        >
                            <p-button
                                icon="pi pi-info-circle"
                                (onClick)="
                                    openVerifiedDocument(
                                        document.id,
                                        document.mimeType
                                    )
                                "
                                [rounded]="true"
                                severity="success"
                            />
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <div class="mt-6">
            <p-button
                (onClick)="goToCustomerDetails()"
                icon="pi pi-arrow-left"
                severity="secondary"
                [label]="'BACK_TO_CUSTOMER' | translate"
            ></p-button>
        </div>
        <ng-template #noDriver>
            <div class="flex gap-2 align-items-center mt-2">
                <i
                    class="pi pi-exclamation-triangle"
                    style="color: orangered"
                ></i>
                <span>{{'Driver has no uploaded documents yet' | translate}}</span>
            </div>
        </ng-template>
    </p-card>
</div>
